import { initReactI18next } from "react-i18next";
import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import resourcesToBackend from 'i18next-resources-to-backend';
import { DefaultLanguage } from "@src/utils/translation";
import { getAppInsights } from "@src/TelemetryProvider";
// Translation files
const translationFiles = {
  "en": () => import(/* webpackChunkName: "i18n-en" */"./en/common.json"),
  "af": () => import(/* webpackChunkName: "i18n-af" */"./af/common.json"),
  "ak": () => import(/* webpackChunkName: "i18n-ak" */"./ak/common.json"),
  "am": () => import(/* webpackChunkName: "i18n-am" */"./am/common.json"),
  "ar": () => import(/* webpackChunkName: "i18n-ar" */"./ar/common.json"),
  "as": () => import(/* webpackChunkName: "i18n-as" */"./as/common.json"),
  "ay": () => import(/* webpackChunkName: "i18n-ay" */"./ay/common.json"),
  "az": () => import(/* webpackChunkName: "i18n-az" */"./az/common.json"),
  "be": () => import(/* webpackChunkName: "i18n-be" */"./be/common.json"),
  "bg": () => import(/* webpackChunkName: "i18n-bg" */"./bg/common.json"),
  "bho": () => import(/* webpackChunkName: "i18n-bho" */"./bho/common.json"),
  "bm": () => import(/* webpackChunkName: "i18n-bm" */"./bm/common.json"),
  "bn": () => import(/* webpackChunkName: "i18n-bn" */"./bn/common.json"),
  "bs": () => import(/* webpackChunkName: "i18n-bs" */"./bs/common.json"),
  "ca": () => import(/* webpackChunkName: "i18n-ca" */"./ca/common.json"),
  "ceb": () => import(/* webpackChunkName: "i18n-ceb" */"./ceb/common.json"),
  "ckb": () => import(/* webpackChunkName: "i18n-ckb" */"./ckb/common.json"),
  "co": () => import(/* webpackChunkName: "i18n-co" */"./co/common.json"),
  "cs": () => import(/* webpackChunkName: "i18n-cs" */"./cs/common.json"),
  "cy": () => import(/* webpackChunkName: "i18n-cy" */"./cy/common.json"),
  "da": () => import(/* webpackChunkName: "i18n-da" */"./da/common.json"),
  "de": () => import(/* webpackChunkName: "i18n-de" */"./de/common.json"),
  "doi": () => import(/* webpackChunkName: "i18n-doi" */"./doi/common.json"),
  "dv": () => import(/* webpackChunkName: "i18n-dv" */"./dv/common.json"),
  "ee": () => import(/* webpackChunkName: "i18n-ee" */"./ee/common.json"),
  "el": () => import(/* webpackChunkName: "i18n-el" */"./el/common.json"),
  "eo": () => import(/* webpackChunkName: "i18n-eo" */"./eo/common.json"),
  "es": () => import(/* webpackChunkName: "i18n-es" */"./es/common.json"),
  "et": () => import(/* webpackChunkName: "i18n-et" */"./et/common.json"),
  "eu": () => import(/* webpackChunkName: "i18n-eu" */"./eu/common.json"),
  "fa": () => import(/* webpackChunkName: "i18n-fa" */"./fa/common.json"),
  "fi": () => import(/* webpackChunkName: "i18n-fi" */"./fi/common.json"),
  "fr": () => import(/* webpackChunkName: "i18n-fr" */"./fr/common.json"),
  "fy": () => import(/* webpackChunkName: "i18n-fy" */"./fy/common.json"),
  "ga": () => import(/* webpackChunkName: "i18n-ga" */"./ga/common.json"),
  "gd": () => import(/* webpackChunkName: "i18n-gd" */"./gd/common.json"),
  "gl": () => import(/* webpackChunkName: "i18n-gl" */"./gl/common.json"),
  "gn": () => import(/* webpackChunkName: "i18n-gn" */"./gn/common.json"),
  "gom": () => import(/* webpackChunkName: "i18n-gom" */"./gom/common.json"),
  "gu": () => import(/* webpackChunkName: "i18n-gu" */"./gu/common.json"),
  "ha": () => import(/* webpackChunkName: "i18n-ha" */"./ha/common.json"),
  "haw": () => import(/* webpackChunkName: "i18n-haw" */"./haw/common.json"),
  "he": () => import(/* webpackChunkName: "i18n-he" */"./he/common.json"),
  "hi": () => import(/* webpackChunkName: "i18n-hi" */"./hi/common.json"),
  "hmn": () => import(/* webpackChunkName: "i18n-hmn" */"./hmn/common.json"),
  "hr": () => import(/* webpackChunkName: "i18n-hr" */"./hr/common.json"),
  "ht": () => import(/* webpackChunkName: "i18n-ht" */"./ht/common.json"),
  "hu": () => import(/* webpackChunkName: "i18n-hu" */"./hu/common.json"),
  "hy": () => import(/* webpackChunkName: "i18n-hy" */"./hy/common.json"),
  "id": () => import(/* webpackChunkName: "i18n-id" */"./id/common.json"),
  "ig": () => import(/* webpackChunkName: "i18n-ig" */"./ig/common.json"),
  "ilo": () => import(/* webpackChunkName: "i18n-ilo" */"./ilo/common.json"),
  "is": () => import(/* webpackChunkName: "i18n-is" */"./is/common.json"),
  "it": () => import(/* webpackChunkName: "i18n-it" */"./it/common.json"),
  "ja": () => import(/* webpackChunkName: "i18n-ja" */"./ja/common.json"),
  "jv": () => import(/* webpackChunkName: "i18n-jv" */"./jv/common.json"),
  "ka": () => import(/* webpackChunkName: "i18n-ka" */"./ka/common.json"),
  "kk": () => import(/* webpackChunkName: "i18n-kk" */"./kk/common.json"),
  "km": () => import(/* webpackChunkName: "i18n-km" */"./km/common.json"),
  "kn": () => import(/* webpackChunkName: "i18n-kn" */"./kn/common.json"),
  "ko": () => import(/* webpackChunkName: "i18n-ko" */"./ko/common.json"),
  "kri": () => import(/* webpackChunkName: "i18n-kri" */"./kri/common.json"),
  "ku": () => import(/* webpackChunkName: "i18n-ku" */"./ku/common.json"),
  "ky": () => import(/* webpackChunkName: "i18n-ky" */"./ky/common.json"),
  "la": () => import(/* webpackChunkName: "i18n-la" */"./la/common.json"),
  "lb": () => import(/* webpackChunkName: "i18n-lb" */"./lb/common.json"),
  "lg": () => import(/* webpackChunkName: "i18n-lg" */"./lg/common.json"),
  "ln": () => import(/* webpackChunkName: "i18n-ln" */"./ln/common.json"),
  "lo": () => import(/* webpackChunkName: "i18n-lo" */"./lo/common.json"),
  "lt": () => import(/* webpackChunkName: "i18n-lt" */"./lt/common.json"),
  "lv": () => import(/* webpackChunkName: "i18n-lv" */"./lv/common.json"),
  "lus": () => import(/* webpackChunkName: "i18n-lus" */"./lus/common.json"),
  "mai": () => import(/* webpackChunkName: "i18n-mai" */"./mai/common.json"),
  "mg": () => import(/* webpackChunkName: "i18n-mg" */"./mg/common.json"),
  "mi": () => import(/* webpackChunkName: "i18n-mi" */"./mi/common.json"),
  "mk": () => import(/* webpackChunkName: "i18n-mk" */"./mk/common.json"),
  "ml": () => import(/* webpackChunkName: "i18n-ml" */"./ml/common.json"),
  "mn": () => import(/* webpackChunkName: "i18n-mn" */"./mn/common.json"),
  "mr": () => import(/* webpackChunkName: "i18n-mr" */"./mr/common.json"),
  "ms": () => import(/* webpackChunkName: "i18n-ms" */"./ms/common.json"),
  "mt": () => import(/* webpackChunkName: "i18n-mt" */"./mt/common.json"),
  "my": () => import(/* webpackChunkName: "i18n-my" */"./my/common.json"),
  "ne": () => import(/* webpackChunkName: "i18n-ne" */"./ne/common.json"),
  "nl": () => import(/* webpackChunkName: "i18n-nl" */"./nl/common.json"),
  "no": () => import(/* webpackChunkName: "i18n-no" */"./no/common.json"),
  "nso": () => import(/* webpackChunkName: "i18n-nso" */"./nso/common.json"),
  "ny": () => import(/* webpackChunkName: "i18n-ny" */"./ny/common.json"),
  "or": () => import(/* webpackChunkName: "i18n-or" */"./or/common.json"),
  "om": () => import(/* webpackChunkName: "i18n-om" */"./om/common.json"),
  "pa": () => import(/* webpackChunkName: "i18n-pa" */"./pa/common.json"),
  "pl": () => import(/* webpackChunkName: "i18n-pl" */"./pl/common.json"),
  "ps": () => import(/* webpackChunkName: "i18n-ps" */"./ps/common.json"),
  "pt": () => import(/* webpackChunkName: "i18n-pt" */"./pt/common.json"),
  "qu": () => import(/* webpackChunkName: "i18n-qu" */"./qu/common.json"),
  "ro": () => import(/* webpackChunkName: "i18n-ro" */"./ro/common.json"),
  "ru": () => import(/* webpackChunkName: "i18n-ru" */"./ru/common.json"),
  "rw": () => import(/* webpackChunkName: "i18n-rw" */"./rw/common.json"),
  "sa": () => import(/* webpackChunkName: "i18n-sa" */"./sa/common.json"),
  "sd": () => import(/* webpackChunkName: "i18n-sd" */"./sd/common.json"),
  "si": () => import(/* webpackChunkName: "i18n-si" */"./si/common.json"),
  "sk": () => import(/* webpackChunkName: "i18n-sk" */"./sk/common.json"),
  "sl": () => import(/* webpackChunkName: "i18n-sl" */"./sl/common.json"),
  "sm": () => import(/* webpackChunkName: "i18n-sm" */"./sm/common.json"),
  "sn": () => import(/* webpackChunkName: "i18n-sn" */"./sn/common.json"),
  "so": () => import(/* webpackChunkName: "i18n-so" */"./so/common.json"),
  "sq": () => import(/* webpackChunkName: "i18n-sq" */"./sq/common.json"),
  "sr": () => import(/* webpackChunkName: "i18n-sr" */"./sr/common.json"),
  "st": () => import(/* webpackChunkName: "i18n-st" */"./st/common.json"),
  "su": () => import(/* webpackChunkName: "i18n-su" */"./su/common.json"),
  "sv": () => import(/* webpackChunkName: "i18n-sv" */"./sv/common.json"),
  "sw": () => import(/* webpackChunkName: "i18n-sw" */"./sw/common.json"),
  "ta": () => import(/* webpackChunkName: "i18n-ta" */"./ta/common.json"),
  "te": () => import(/* webpackChunkName: "i18n-te" */"./te/common.json"),
  "tg": () => import(/* webpackChunkName: "i18n-tg" */"./tg/common.json"),
  "th": () => import(/* webpackChunkName: "i18n-th" */"./th/common.json"),
  "tk": () => import(/* webpackChunkName: "i18n-tk" */"./tk/common.json"),
  "ti": () => import(/* webpackChunkName: "i18n-ti" */"./ti/common.json"),
  "tl": () => import(/* webpackChunkName: "i18n-tl" */"./tl/common.json"),
  "tr": () => import(/* webpackChunkName: "i18n-tr" */"./tr/common.json"),
  "ts": () => import(/* webpackChunkName: "i18n-ts" */"./ts/common.json"),
  "tt": () => import(/* webpackChunkName: "i18n-tt" */"./tt/common.json"),
  "ug": () => import(/* webpackChunkName: "i18n-ug" */"./ug/common.json"),
  "uk": () => import(/* webpackChunkName: "i18n-uk" */"./uk/common.json"),
  "ur": () => import(/* webpackChunkName: "i18n-ur" */"./ur/common.json"),
  "uz": () => import(/* webpackChunkName: "i18n-uz" */"./uz/common.json"),
  "vi": () => import(/* webpackChunkName: "i18n-vi" */"./vi/common.json"),
  "xh": () => import(/* webpackChunkName: "i18n-xh" */"./xh/common.json"),
  "yi": () => import(/* webpackChunkName: "i18n-yi" */"./yi/common.json"),
  "yo": () => import(/* webpackChunkName: "i18n-yo" */"./yo/common.json"),
  "zh-CN": () => import(/* webpackChunkName: "i18n-zh-CN" */"./zh-CN/common.json"),
  "zh-TW": () => import(/* webpackChunkName: "i18n-zh-TW" */"./zh-TW/common.json"),
  "zu": () => import(/* webpackChunkName: "i18n-zu" */"./zu/common.json"),
}


i18next
  .on("failedLoading", (lng, ns, msg) => {
    const err = new Error(`i18next failed to load ${lng}/${ns}: ${msg}`);
    const appInsights = getAppInsights();

    appInsights.trackException({ exception: err });
    console.error(err.message, err);
  });

i18next
  .use(LanguageDetector)
  .use(resourcesToBackend((language: keyof typeof translationFiles) =>
    translationFiles[language] ? translationFiles[language]() : null)
  )
  .use(initReactI18next)
  .init({
    debug: process.env.NODE_ENV === "development",
    interpolation: { escapeValue: false },
    fallbackLng: DefaultLanguage.code
  }, (err, _) => {
    if (err) {
      console.error('i18next initialization error:', err);
      const appInsights = getAppInsights();
      appInsights.trackException({ exception: err });
    }
    else console.log('i18next initialized successfully');
  });

export { i18next };
